import React, { useEffect, useCallback, useMemo } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { pathNames, routesObj, SourceRoute } from '../routers/router'
import { refreshAccessTokenAdmin } from '../utils/axios'
import { setAccessToken, setRefreshToken, removeSessionStorage, keyNameSessionStorage } from '../utils/sessionStorage'

import Layout from '../Layout'

import useQueryString from '../hooks/useQueryString'
import useStore from '../stores/useStore'

// type TUseLandingPageAdmin = ReturnType<typeof useLandingPageAdmin>

const useLandingPageAdmin = () => {
    const { userStore } = useStore()
    const { values: cmsToken } = useQueryString({ keys: ['accessToken', 'refreshToken'] })
    const [cmsAcceptToken, cmsRefreshToken] = cmsToken

    const onCallBack = useCallback(async () => {
        if (cmsAcceptToken && cmsRefreshToken) {
            setAccessToken(cmsAcceptToken)
            setRefreshToken(cmsRefreshToken)
            try {
                await refreshAccessTokenAdmin(cmsRefreshToken)
                await userStore.getUserProfileAdmin()
            } catch (error) {
                removeSessionStorage([
                    keyNameSessionStorage.user,
                    keyNameSessionStorage.accessToken,
                    keyNameSessionStorage.refreshToken,
                ])
                window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
            }
        } else {
            userStore.getUserProfileAdmin().catch(() => {
                window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const routesObjAdmin = useMemo(() => {
        const adminRoutes = routesObj.admin!.routes as SourceRoute[]
        const funcMenuAdmin = userStore.profileInfo.accessMenus?.[0].functions ?? []
        const finalRoutes = adminRoutes.filter((route) =>
            funcMenuAdmin?.some((func) => route.key === func.functionCode),
        )
        return {
            pathName: finalRoutes?.[0]?.path,
            routes: adminRoutes.filter((route) => funcMenuAdmin?.some((func) => route.key === func.functionCode)),
        }
    }, [userStore.profileInfo.accessMenus])

    useEffect(() => {
        onCallBack()
    }, [onCallBack])

    return { routesObjAdmin, userStore }
}

let LandingPageAdmin = (props: any) => {
    const { userStore } = useLandingPageAdmin()
    return userStore?.profileInfo?.routers?.pathNameDefault ? (
        <>
            <Route
                path={pathNames.admin}
                render={() => {
                    return <Redirect to={userStore?.profileInfo?.routers?.pathNameDefault} />
                }}
            />

            <Layout routes={userStore?.profileInfo?.routers?.routes as SourceRoute[]} />
        </>
    ) : (
        <></>
    )
}

LandingPageAdmin = observer(LandingPageAdmin)

export default LandingPageAdmin
